import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '@/components/MainLayout';
import PublicLayout from '@/components/PublicLayout';

import DashboardPage from '@/pages/dashboard/page';
import LoginPage from '@/pages/login/page';
import AuthCallbackPage from '@/pages/auth/callback/page';
import SignOutPage from '@/pages/signout/page';
import ProfilePage from '@/pages/profile/page';
import NotificationsPage from '@/pages/notifications/page';
import MyApplicationsPage from '@/pages/myapplications/page';
import ChildDetailPage from '@/pages/students/[id]/page';
import ParentConductPage from '@/pages/students/[id]/sign-charter/page';
import UpdateStudentInfoPage from '@/pages/students/[id]/update-info/page';
import UpdateDocumentsPage from '@/pages/students/[id]/update-documents/page';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/signout" element={<SignOutPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/myapplications" element={<MyApplicationsPage />} />
        <Route path="/students/:id" element={<ChildDetailPage />} />
        <Route path="/students/:id/sign-charter" element={<ParentConductPage />} />
        <Route path="/students/:id/update-info" element={<UpdateStudentInfoPage />} />
        <Route path="/students/:id/update-documents" element={<UpdateDocumentsPage />} />
        <Route path="/students/:id/update-documents/:appId" element={<UpdateDocumentsPage />} />
      </Route>
    </Routes>
  );
}
